<template>
  <div class="self-service-auto-reply">
    <em
      class="self-service-auto-reply__icon iconfont icon-service"
      aria-hidden="true"
    ></em>
    <div class="self-service-auto-reply__bubble">
      <p v-if="orderIdText" class="self-service-auto-reply__order">
        {{ orderIdText }}
      </p>
      <p class="self-service-auto-reply__text">{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelfServiceAutoReply',
  props: {
    text: {
      type: String,
      default: ''
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    orderIdLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    orderIdText() {
      const id = String(this.orderId || '').trim();
      if (!id || id === '0') {
        return '';
      }
      const label = (this.orderIdLabel || '').trim();
      return label ? `${label}: ${id}` : id;
    }
  }
};
</script>
